import ProfileTitleCell from '../ProfileTitleCell'
import { CellInfo } from '../types'

export const ProfileTitleRowCell = (info: CellInfo) => {
  if (!info) {
    return null
  }

  const {
    row: { original: profileData },
    meta: { selectedRowIds, onSelectProfile, onClickProfile },
  } = info

  const isActive = profileData.profileStatus === 'active'

  return (
    <ProfileTitleCell
      profileData={profileData}
      isPrivate={profileData.profileImgData?.isPrivate}
      isSelectedProfile={selectedRowIds.includes(profileData.profileId)}
      onSelectProfile={onSelectProfile}
      onClickProfile={onClickProfile}
      isDisabled={!isActive}
    />
  )
}
